module.exports = __webpack_public_path__ + "static/img/2_8_1.d107c7d2.jpg";